import {
  type DateFieldProps,
  type DateInputProps,
  DateSegment,
  type DateValue,
  DateField as RACDateField,
  DateInput as RACDateInput,
} from "react-aria-components";
import { tv } from "tailwind-variants";

import { composeTailwindRenderProps } from "@/components/ui/utils";

export function DateField<T extends DateValue>(props: DateFieldProps<T>) {
  return (
    <RACDateField
      {...props}
      className={composeTailwindRenderProps(
        props.className,
        "flex flex-col gap-1",
      )}
    >
      <DateInput />
    </RACDateField>
  );
}

const segmentStyles = tv({
  base: [
    "inline rounded p-0.5 text-foreground caret-transparent  outline-0 data-[type=literal]:px-0 data-[type=literal]:text-muted-foreground/70",
  ],
  variants: {
    isPlaceholder: {
      true: "text-muted-foreground/70",
    },
    isFocused: {
      true: "bg-accent text-foreground",
    },
    isDisabled: {
      true: "opacity-50 cursor-not-allowed",
    },
    isInvalid: {
      true: "text-destructive",
    },
  },
  compoundVariants: [
    {
      isFocused: true,
      isPlaceholder: true,
      class: "text-foreground",
    },
    {
      isInvalid: true,
      isPlaceholder: true,
      class: "text-muted-foreground/70",
    },
  ],
});

export function DateInput(props: Omit<DateInputProps, "children">) {
  return (
    <RACDateInput
      className="px-2 text-sm"
      // className={(renderProps) =>
      //   fieldGroupStyles({
      //     ...renderProps,
      //     class: "relative inline-flex",
      //   })
      // }
      {...props}
    >
      {(segment) => <DateSegment segment={segment} className={segmentStyles} />}
    </RACDateInput>
  );
}
